import { CREATE_MAGAZINE_START } from "../../types";

export const create_magazine = (payload) => ({
  type: CREATE_MAGAZINE_START,
  payload,
});
